<template>
  <div class="#app">
    <div>
      <carousel :msg="swiper" />
    </div>
    <div class="content">
      <div class="content-title" v-if="this.$store.state.num == 2">
        <span class="index"> 首页&nbsp;/ </span>
        <span class="location">地质旅游</span>
      </div>

      <div class="content-title" v-else>
        <span class="index"> Home&nbsp;/ </span>
        <span class="location">Tourism</span>
      </div>



      <div class="lifestyle">
        <!-- 中英文版 -->
        <div class="habit-select"  v-if="this.$store.state.num == 2 ||this.$store.state.num == null">
          <span class="chosen" :class="activeBgi == index ? 'active' : ''" @click="changeChosen(index, item.url)"
            v-for="(item, index) in linehead" :key="index">
            <span>{{ item.name }}</span>
          </span>
          
        </div>
        <div class="habit-select"  v-else>
          <span class="chosen" :class="activeBgi == index ? 'active' : ''" @click="changeChosen(index, item.url)"
            v-for="(item, index) in linehead" :key="index">
            <span>{{ item.yname }}</span>
          </span>
        </div>
        <!-- 中英文版 end -->
        <div class="select-one">
          <div class="selected">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "../../conponent/Carousel.vue";
import { swiper } from "../../api/api.js";

export default {
  name: "",
  props: {},
  activeBgi: 0,
  components: { carousel },
  data() {
    return {
      activeBgi: 0,
      linehead: [
        {
          name: "景点介绍",
          yname: "Tourist Sites",
          url: "/travel",
        },
        {
          name: "食在兴文",
          yname: "Cuisine in Xingwen",
          url: "/eat",
        },
        {
          name: "住在兴文",
          yname: "Hospitality in Xingwen",
          url: "/live",
        },
        {
          name: "行在兴文",
          yname: "Transportation in Xingwen",
          url: "/walk",
        },
        {
          name: "玩在兴文",
          yname: "Entertainment in Xingwen",
          url: "/play",
        },
      ],
      swiper: [],
      carousel: {
        imgType: 5,
        column: "order_num",
        order: "desc",
      },
    };
  },
  created() {
    this.activeBgi = this.$store.state.travelIndex
    this.changeChosen(this.activeBgi, this.linehead[this.activeBgi].url)
    swiper(this.carousel).then((res) => {
      this.swiper = res.data.result.records;
    });
  },
  methods: {
    changeChosen(index, url) {
      this.activeBgi = index;
      this.$store.commit('edittravelIndex', { num: index })
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style scoped lang="less">
.travel {
  height: 350px;
}

.content {
  background: rgb(235, 235, 235);
  min-height: 700px;
  padding-bottom: 30px;
}

.content-title {
  height: 50px;
  margin: 0 auto;
  width: 1000px;
  text-align: left;
  padding-top: 15px;
  font-style: italic;
}

.content-title .index {
  font-size: 16px;
}

.content-title .location {
  font-size: 17px;
  font-weight: bold;
}

.lifestyle {
  margin: 0 auto;
  width: 1000px;
  min-height: 600px;
  background: rgb(235, 235, 235);
  display: flex;
  padding-bottom: 30px;
}

.habit-select {
  height: 500px;
  width: 400px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
}

.habit-select .chosen {
  margin-bottom: 6px;
  // width: 150px;
  font-size: 20px;
  color: black;
}

.active {
  background-image: url("../../assets/img/chosen-tab.jpg");
  background-size: 100% 100%;
  color: white !important
}

.select-one {
  background: rgb(235, 235, 235);
  width: 800px;
  padding-top: 30px;
}

.selected {
  width: 750px;
  background: white;
  min-height: 500px;
}
</style>
